import { Button } from "@/components/ui/atoms/Button";
import { Typography } from "../ui/atoms/Typography";

interface SuggestionPillProps {
  label: string;
  onClick: () => void;
}

export function SuggestionPill({ label, onClick }: SuggestionPillProps) {
  return (
    <Button
      type="outlined"
      intent="muted"
      size="sm"
      aria-label={label}
      onMouseDown={(event) => {
        // Prevent the input losing focus when tapping a suggestion on mobile
        event.preventDefault();
      }}
      onClick={onClick}
      className="mr-auto min-w-0 !rounded-lg !border !border-purple !bg-light px-3.5 py-2 shadow-sm transition-all hover:-translate-y-px hover:!border-purple hover:shadow-md focus-visible:!border-purple focus:!ring-purple/30"
    >
      <Typography variant="body-sm" weight="semibold" color="primary">{label}</Typography>
    </Button>
  );
}